import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {AlertService} from '../../shared/services/alert.service';
import {Messages} from '../../shared/constants/messages';
import {PermissionService} from '../services/permission.service';

export const organizationPublishGuard: CanActivateFn = (route) => {
  const router: Router = inject(Router);
  const alertService: AlertService = inject(AlertService);
  const permissionService: PermissionService = inject(PermissionService);

  if (!permissionService.isLogged()) {
    alertService.showError(Messages.LOGIN_REQUIRED);
    return router.navigate(['/login']);
  }

  const publishKind = route.data['publish'] as 'event' | 'table' | undefined;
  const allowed = publishKind === 'table'
    ? permissionService.canCreateTable()
    : permissionService.canCreateEvent();

  if (allowed) {
    return true;
  }

  alertService.showError(Messages.ORGANIZATION_CONTENT_CREATE_ONLY);
  return router.navigate(['/home']);
};
